import { Components, Theme } from '@mui/material';

export const chipOverrides: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    colorSuccess: ({ theme }) => ({
      color: theme.palette.success.light,
      background: theme.palette.success.dark,
    }),
    sizeSmall: {
      height: 22,
      fontSize: 12,
    },
    colorWarning: ({ theme }) => ({
      color: theme.palette.warning.main,
      background: theme.palette.warning.light,
    }),
    colorError: ({ theme }) => ({
      color: theme.palette.error.dark,
      background: theme.palette.error.light,
    }),
    colorInfo: ({ theme }) => ({
      color: theme.palette.info.dark,
      background: theme.palette.background.paper,
    }),
    root: {
      fontFamily: 'DM Sans',
      fontSize: 16,
      fontWeight: 'medium',
      padding: '2px 6px',
      borderRadius: '8px',
      width: 'fit-content',
      height: 26,
      '.MuiChip-label': {
        padding: 0,
      },
      '.MuiChip-icon': {
        margin: 0,
        marginRight: 4,
      },
    },
  },
};
